import { forOwn } from 'lodash';
import parserMap from './parser-map';
import {
  Category,
  Match,
  Sport,
  Tournament,
} from '../models';

const formatMeta = (rawData) => {
  const tournaments = {};
  const categories = {};
  const sports = {};

  forOwn(rawData[parserMap.tournaments], (value) => {
    const parsedTour = new Tournament(value);
    tournaments[parsedTour.id] = parsedTour;
  });

  forOwn(rawData[parserMap.categories], (value) => {
    const parsedCategory = new Category(value);
    categories[parsedCategory.id] = parsedCategory;
  });

  forOwn(rawData[parserMap.sports], (value) => {
    const parsedSport = new Sport(value);
    sports[parsedSport.id] = parsedSport;
  });

  return {
    tournaments,
    categories,
    sports,
  };
};

const formatResults = (rawData) => {
  const matches = [];
  const categories = {};
  const tournaments = {};
  const sports = {};

  rawData[parserMap.matches].map(value => matches.push(new Match(value, true)));

  forOwn(rawData[parserMap.tournaments], (value) => {
    const parsedTour = new Tournament(value);
    tournaments[parsedTour.id] = parsedTour;
  });

  forOwn(rawData[parserMap.categories], (value) => {
    const parsedCategory = new Category(value);
    categories[parsedCategory.id] = parsedCategory;
  });

  forOwn(rawData[parserMap.sports], (value) => {
    const parsedSport = new Sport(value);
    sports[parsedSport.id] = parsedSport;
  });

  return {
    matches,
    categories,
    sports,
    tournaments,
  };
};

export default {
  formatMeta,
  formatResults,
};
